angular.module('aprima-core-ui').directive('apPdf', [
        function apPdf() {
            'use strict';

            return {
                restrict: 'E',
                link: function(scope, element, attrs) {
                    var data = scope.$eval(attrs.src);
                    element.replaceWith('<object type="application/pdf" data="' + data + '" width="100%" height="800"></object>');
                }
            };
        }]);